<div class="ghost"></div>
<div class="header mobile-header-only">
  <div class="wrapper-home" (click)="goToZilex()">

    <div class="placeholder"></div>

  </div>
  <app-header></app-header>
  <app-language-menu (onLanguageChange)="vmOnLanguageChange($event)"></app-language-menu>
</div>
<div class="main-container">

  <div class="header desktop-header-only">
    <div class="wrapper-home" (click)="goToZilex()">
      <div class="icon-wrapper">
        <div class="placeholder"></div>
      </div>
      <div class="text">
        zilex.de
      </div>
    </div>
    <app-header></app-header>
    <app-language-menu (onLanguageChange)="vmOnLanguageChange($event)"></app-language-menu>
  </div>
  <div class="wrapper-main">
    <div class="wrapper-right">
      <form #registrationForm="ngForm" class="settings-form" (submit)="submit(registrationForm)"
        *ngIf="!registrationSuccessful">

        <div class="field field-tips">
          <div class="label-wrapper">
            <label for="companyName">{{'registration.form.fields.companyName' | translate}}:</label>
            <span class="tips">{{'registration.form.fields.companyTip' | translate}}</span>
          </div>
          <input type="text" name="companyName" id="companyName" [(ngModel)]="formCredentials.companyName"
            (keydown)="preventEnterKeyTigger($event)" required>
        </div>


        <div class="field">
          <label for="firstName">{{'registration.form.fields.firstName' | translate}}:</label>
          <input type="text" name="firstName" id="firstName" [(ngModel)]="formCredentials.name"
            (keydown)="preventEnterKeyTigger($event)" required>
        </div>

        <div class="field">
          <label for="surname">{{'registration.form.fields.lastName' | translate}}:</label>
          <input type="text" name="surname" id="surname" [(ngModel)]="formCredentials.surname"
            (keydown)="preventEnterKeyTigger($event)" required>
        </div>

        <div class="field">
          <label for="mail">{{'registration.form.fields.email' | translate}}:</label>
          <input type="email" name="mail" id="mail" [(ngModel)]="formCredentials.mail"
            (keydown)="preventEnterKeyTigger($event)" required>
        </div>

        <!-- field start -->
        <div class="field">
          <label for="password">{{'setupPasswordPage.password' | translate}}:</label>
          <input type="password" name="password" id="password" [(ngModel)]="formCredentials.password"
            (input)="validate()" required>
        </div>
        <!-- field end -->
        <!-- field start -->
        <div class="field">
          <label for="confirmPassword">{{'setupPasswordPage.confirmPassword' | translate}}:</label>
          <input type="password" name="confirmPassword" id="confirmPassword"
            [(ngModel)]="formCredentials.confirmPassword" required>
        </div>
        <!-- field end -->

        <div>
          <div class="invalidMsg" *ngIf="allFieldsRequired">
            {{'registration.form.validationMsg.allFieldsRequired'|translate}}</div>

          <div class="invalidMsg" *ngIf="completeCaptcha">
            {{'registration.form.validationMsg.completeCaptcha'|translate}}</div>

          <div class="invalidMsg" *ngIf="passwordsNotEqual">
            {{'registration.form.validationMsg.passwordsNotEqual'|translate}}</div>

          <div class="warningMsg" *ngIf="passwordLengthFail">
            {{'registration.form.validationMsg.passwordLengthCheckFail'|translate}}</div>
          <div class="warningMsg" *ngIf="passwordSymbolFail">
            {{'registration.form.validationMsg.passwordSymbolCheckFail'|translate}}</div>
          <div class="warningMsg" *ngIf="passwordLetterOrNumberFail">
            {{'registration.form.validationMsg.passwordLetterOrNumberFail'|translate}}</div>

          <div class="invalidMsg" *ngIf="emailNotValid">{{'registration.form.validationMsg.emailNotValid'|translate}}
          </div>

          <div class="invalidMsg" *ngIf="apiErrorMessage">{{apiErrorMessage}}</div>
        </div>
        <div class="buttons-block">
          <button type="submit" class="btn btn-green">{{'registration.form.buttons.register' | translate}}</button>

          <button class="btn" (click)="cancel($event);">{{'registration.form.buttons.cancel' |
            translate}}</button>

        </div>
      </form>
      <div class="msg-after-reg" *ngIf="registrationSuccessful">{{'registration.form.validationMsg.confirmMessage' |
        translate}}</div>
    </div>
  </div>

</div>